"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Store_1 = require("owa-mail-list-store/lib/store/Store");
var deleteConversations_1 = require("./deleteConversations");
var deleteItems_1 = require("./deleteItems");
var getInstrumentationContextsFromTableView_1 = require("owa-mail-list-store/lib/utils/getInstrumentationContextsFromTableView");
function deleteMailListRows(rowKeys, originalTableViewId, isExplicitSoftDelete, actionSource) {
    var tableView = Store_1.default.tableViews.get(originalTableViewId);
    var instrumentationContexts = getInstrumentationContextsFromTableView_1.default(rowKeys, tableView);
    switch (tableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            deleteConversations_1.deleteConversationsFromTable(rowKeys, originalTableViewId, isExplicitSoftDelete, instrumentationContexts, actionSource);
            break;
        case 1 /* Message */:
            deleteItems_1.deleteItemsFromTable(rowKeys, originalTableViewId, isExplicitSoftDelete, instrumentationContexts, actionSource);
            break;
    }
}
exports.default = deleteMailListRows;
//# sourceMappingURL=deleteMailListRows.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/deleteMailListRows.js
// module id = 3467
// module chunks = 62